module.exports = __webpack_public_path__ + "img/max-envelope-search.7d5b17de.svg";